import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { ReferencePersonFormViewProps } from "models/propTypes/customerPropTypes";
import { FormEnums } from "models/enums";
import { FormHandles, NumberFormatFieldExtraProps } from "models/propTypes/genericFormProps";
import { CustomerFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { CommonConstants, IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { GenericForm } from "components/common";
import ReferenceCodeChangeWarning from "./referenceCodeChangeWarning";
//#endregion

const ReferencePersonForm: ForwardRefRenderFunction<FormHandles, ReferencePersonFormViewProps> = (props, ref) => {
  const { emailsUpdateHandler, referenceId: initialReferenceId } = props;

  return (
    <GenericForm<CustomerFormTypes.ReferencePerson>
      formRef={ref}
      {...props}
      fields={{
        name: {
          label: TranslationKeys.Common.Name,
          icon: IconDefinitionConstants.WUser,
          type: FormEnums.FormFieldType.TEXT,
          descriptionText: TranslationKeys.Invoice.ReferencePersonNameDescription,
        },
        emailSplit: {
          label: TranslationKeys.Common.Email,
          type: FormEnums.FormFieldType.MULTIPLEINPUT,
          descriptionText: TranslationKeys.Invoice.ReferencePersonEmailDescription,
          onChangeHandler: emailsUpdateHandler,
          innerFields: {
            emailSplit: {
              label: TranslationKeys.Common.Email,
              icon: IconDefinitionConstants.WAt,
              type: FormEnums.FormFieldType.EMAIL,
            },
          },
        },
        phoneNumber: {
          label: TranslationKeys.Common.Phone,
          icon: IconDefinitionConstants.WPhone,
          type: FormEnums.FormFieldType.NUMBER,
          descriptionText: TranslationKeys.Invoice.ReferencePersonPhoneDescription,
          extraProps: {
            allowLeadingZeros: true,
            format: CommonConstants.PhoneNumberMask,
          } as NumberFormatFieldExtraProps,
        },
        referenceId: {
          label: TranslationKeys.Common.ReferenceId,
          icon: IconDefinitionConstants.WThumbPrint,
          type: FormEnums.FormFieldType.TEXT,
          descriptionText: TranslationKeys.Invoice.ReferencePersonReferenceCodeDescription,
          hidden: (values: CustomerFormTypes.ReferencePerson) => !values.isEInvoicesEnabled,
          customContentAfter: (values: CustomerFormTypes.ReferencePerson) => (
            <ReferenceCodeChangeWarning
              initialReferenceId={initialReferenceId}
              referenceId={values.referenceId}
              name={values.name}
            />
          ),
        },
        isDefault: {
          label: TranslationKeys.Common.UseByDefault,
          type: FormEnums.FormFieldType.TOGGLE,
        },
      }}
    />
  );
};

export default forwardRef(ReferencePersonForm);
